import React, { FC, useState } from 'react'
import t from 'src/translations/main'
import useFetch from 'src/components/Core/Hooks/useFetch/useFetch'
import useForm from 'src/components/Core/Hooks/useForm/useForm'
import utils from 'src/components/Organisms/Form/utils'
import config from './config'
import updateModal from 'src/components/Sections/Modal/updateModal'
import storage from 'src/components/Core/Utils/storage'
import { parseJson } from 'src/views/Pages/Onboarding/FormWrapper'
import { useContactsDetails, useContactsDetailsUpdate } from 'src/components/Core/Context/OnboardingContext'

import Button from 'src/components/Atoms/Button/Button'
import Spinner from 'src/components/Core/Loading/Spinner/Spinner'
import Popup from 'src/components/Atoms/Popup/Popup'

import {
  FormStyle,
  FormFooter,
  FormFooterActionsRight,
} from 'src/components/Organisms/Form/Form.styles'

import { ApiData, TableObj } from 'src/views/Pages/Onboarding/types'
import { ModalContactDetailsProps } from './types'

const ModalContactDetailsForm: FC<ModalContactDetailsProps> = props => {
  const { actionType } = props
  const [serverValidationError, setServerValidationError] = useState('')
  const { isLoading, error, sendRequest } = useFetch()
  const tableData = useContactsDetails()
  const updateContactsTableData = useContactsDetailsUpdate()

  const getFetchedData = () => {
    const rowData = [...tableData].filter(
      tableDataObj => tableDataObj.id === props.id
    )
    return utils.transformTableObj(
      rowData[0],
      props.tableConfig
    )
  }

  const fetchedData = actionType === 'add' ? {} : getFetchedData()

  const submitForm = (submitData: ApiData) => {
    if (actionType === 'edit') submitData.data.id = fetchedData.id

    // eslint-disable-next-line
    const modifyResponse = (data: any) => {
      const serverValidationErrorsParsed = parseJson(data?.reasonPhrase)
      if(serverValidationErrorsParsed && serverValidationErrorsParsed[0].key === 'generalError') {
        setServerValidationError(t(`onboarding.errors.${serverValidationErrorsParsed[0].errorcode}`) || serverValidationErrorsParsed[0].errordescription?.split(':')[1] || t('error.invalidValue'))
        return
      }
      if(Array.isArray(serverValidationErrorsParsed) && serverValidationErrorsParsed.length > 0) {
        submitData.setConfigData(utils.injectErrorPropToConfig(submitData.configData, [], serverValidationErrorsParsed))
        return
      }

      if (data) {
        updateModal({ modalState: 'close' })
        if (actionType === 'add') {
          submitData.data.id = data
          updateContactsTableData((prevState: TableObj[]) => {
            return utils.addRowToTableData(
              [...prevState],
              submitData.data,
              props.tableConfig,
              props.action
            )
          })
        }
        if (actionType === 'edit') {
          updateContactsTableData((prevState: TableObj[]) => {
            return utils.getEditedTableData(
              [...prevState],
              submitData.data,
              props.tableConfig,
              props.action
            )
          })
        }
      }
    }
    submitData.data.applicationId = storage?.get(storage?.keys?.onboarding?.applicationId)
    sendRequest(
      {
        scope: 'onboarding',
        url: props.postUrl,
        method: 'POST',
        body: submitData.data,
      },
      modifyResponse
    )
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
  } = useForm(
    fetchedData,
    config,
    submitForm
  )

  if (isLoading) return <Spinner removeFullscreen />

  if (error) return <p>{error?.message || error}</p>

  return (
    <FormStyle onSubmit={handleSubmit}>
      {utils.sectionBuilder(config, formData, handleInputChange)}
      <FormFooter insideModal>
        <FormFooterActionsRight>
          <Button
            version={2}
            label={t('onboarding.main.cancelButton')}
            onClick={() => updateModal({ modalState: 'close' })}
          />
          <Button
            type='submit'
            label={t('onboarding.main.saveButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
      {!isLoading && (error || serverValidationError) && <Popup type='error' label={error || serverValidationError} popupContainerWidth='auto' popupContainerHeight='auto'/>}
    </FormStyle>
  )
}

export default ModalContactDetailsForm
